import React from 'react'

import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => {
  const height = theme.spacing(12)
  return {
    root: {
      position: 'absolute',
      right: `-${height / 4}px`,
      bottom: '0',
      top: '0',
      width: '0',
      height: '0',
      borderStyle: 'solid',
      borderWidth: `${height / 2}px 0 ${height / 2}px ${height / 4}px`,
      borderColor: `transparent transparent transparent gray`,
    },
  }
})

const PointerTriangle: React.FC = () => {
  const classes = useStyles()

  return <div className={`${classes.root} arrow-item`} />
}

export default PointerTriangle
